import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';
import t from '../../Components/Translations/lang.json';
// import Script from 'react-load-script';

const Postal = (props) => {
    const [address, setAddress] = React.useState('');

    const handleChange = (address) => {
        setAddress(address);
    };

    const handleSelect = async (address, placeId) => {
        setAddress(address);

        const results = await geocodeByAddress(address);
        const latLng = await getLatLng(results[0]);
        const [place] = await geocodeByPlaceId(placeId);
        const { long_name: postalCode = '' } =
            place.address_components.find((c) =>
                c.types.includes('postal_code')
            ) || {};
        props.onPostalSelect(postalCode);
	props.onAddressChange(address);
        console.log('postalCode', postalCode);
	console.log('address', address);

        geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => console.log('Success', latLng))
            .catch((error) => console.error('Error', error));
    };

    return (
        <>
            <PlacesAutocomplete
                value={address}
                onChange={handleChange}
                onSelect={handleSelect}
            >
                {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                }) => (
                    <div>
                        <input
                            {...getInputProps({
                                placeholder: `${
                                    t[props.lang].searchPlacesPlaceholder
                                }`,
                                className:
                                    'location-search-input input-field mt-4',
                            })}
                        />
                        <div className='autocomplete-dropdown-container'>
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion, index) => {
                                const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                    ? {
                                          backgroundColor: '#fafafa',
                                          cursor: 'pointer',
                                      }
                                    : {
                                          backgroundColor: '#ffffff',
                                          cursor: 'pointer',
                                      };
                                return (
                                    <div
                                    key ={index}
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        </>
    );
};

export default Postal;
